// extracted by mini-css-extract-plugin
module.exports = {"noteContainer":"NoteInput_noteContainer__1PTP6","noteWrapper":"NoteInput_noteWrapper__3D0Dc","noteInput":"NoteInput_noteInput__1-4Pz","highlight":"NoteInput_highlight__2bdA9"};